/**
 * Hardware Secure Crypto Robustness.
 *
 * @group DRM
 *
 * @beta
 */
export const HW_SECURE_CRYPTO = 'HW_SECURE_CRYPTO';
